// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"57":"e2245831","287":"7b7dbac0","385":"fc2137fa","762":"d8b46517","869":"52551afb"}[chunkId] + ".js";
};